import { Component } from '@mycolorway/tao';
import $ from 'jquery';
import dialog from 'simple-dialog';
import 'next/stylesheets/components/users/wechat-qrcode-verifier.scss';

Component('tr-wechat-qrcode-verifier', {
  properties: {
    qrcodeUrl: String,
  },

  connected() {
    this.loadQrcode();
  },

  loadQrcode() {
    $.ajax({
      url: this.qrcodeUrl,
      type: 'get',
      dataType: 'json',
      success: (result) => {
        if (result.success) {
          this.showQrcode(result.qrcode_url);
          this.subscribeChannel(result.channel);
        } else {
          dialog.message({ content: result.message });
        }
      },
    });
  },

  showQrcode(qrcodeUrl) {
    $(this).find('.verifier-qrcode-wrap').removeClass('loading');
    $(this).find('.indicator').remove();
    this.querySelector('.qrcode').src = qrcodeUrl;
  },

  subscribeChannel(channelName) {
    const channel = window.tower.tempPusher(channelName);
    channel.bind('WECHAT_AUTH', (result) => {
      if (result.success) {
        const data = { 'users_wechat_verifier[signature]': result.signature };
        $.ajax({
          url: '/users/wechat_verifier',
          type: 'post',
          data,
          success: (res) => {
            if (res.success) {
              this.namespacedTrigger('success', { bubbles: true });
            }
          },
        });
      } else {
        dialog.message({ content: result.message });
      }
    });
  },
});
